import { apiFetch } from "@/api/APIClient";

export interface PaymentConfiguration {
  storeId: string;
  channelKey: string;
  itemCode: string;
}

export async function getPaymentConfiguration(): Promise<PaymentConfiguration> {
  const response = await apiFetch("api/payment/configuration");

  if (!response.ok) {
    throw new Error("결제 설정을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.");
  }

  return response.json();
}
